import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { Card, CardHeader } from 'react-bootstrap'
import { FaUser } from "react-icons/fa";
import './ProfileDatas.css'
import formats from "../../controller/views/formats"
import { GetUserContext } from '../../Context/GetUserContext';
import Company from '../../controller/api/Company';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

const ProfileDatas = () => {
    const { size, fetchTimestampApp, setFetchTimestampApp, loadData, userDatas, profileData, axiosConfig } = useContext(GetUserContext);
    const [show, setShow] = useState(false);
    const [menssageStatus, setMenssageStatus] = useState('')

    const newCompany = new Company()
    const [isEditData, setIseditData] = useState(false)
    const [nomeEmpresa, setNomeEmpresa] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [endereco, setEndereco] = useState('');
    const [telefone, setTelefone] = useState('');
    const [email, setEmail] = useState('');
    const [site, setSite] = useState('');
    const [comprador, setComprador] = useState('');
    const [password, setPassword] = useState('')
    const [passwordConfirm, setPasswordConfirm] = useState('')

    const [cep, setCep] = useState('')
    const [logradouro, setLogradouro] = useState('')
    const [localidade, setLocalidade] = useState('')
    const [bairro, setBairro] = useState('')
    const [uf, setUf] = useState('')
    const [cepResult, setCepResult] = useState('')
    const [number, setNumber] = useState('')
    const [ibeCode, setIbeCode] = useState('')
    const [region, setRegion] = useState('')
    const [address, setAddress] = useState({})
    const [sigla, setSigla] = useState('')

    const handleClose = () => {
        setPassword('')
        setPasswordConfirm('')
        setShow(false)
        window.location.reload();
    };

    useEffect(() => {
        if (profileData && !loadData) {
            setNomeEmpresa(profileData?.Corporate_Name || '');
            setCnpj(profileData?.CNPJ || '');
            setEndereco(`${profileData?.address?.Name}, ${profileData?.address?.Number} - ${profileData?.address?.neighborhood?.Name}, ${profileData?.address?.city?.Name} - ${profileData?.address?.state?.Uf}, ${profileData?.address?.Cep}`);
            setTelefone(profileData?.Landline || '');
            setEmail(profileData?.Email || '');
            setSite(profileData?.Web_Site || '');
            setComprador(userDatas?.user_and_companies?.[0]?.user?.Name || '');
        }
    }, [profileData, userDatas, loadData]);

    const handleEditDatas = () => {
        setIseditData(prev => !prev)
    }

    const handleSubmitEdicao = () => {
        const dadosEditados = {
            Company_ID: profileData?.Company_ID,
            nomeEmpresa,
            cnpj,
            endereco,
            telefone,
            email,
            site,
            comprador
        };

        newCompany.editDataCompany(dadosEditados, axiosConfig)
            .then(response => {
                console.log(response)
                window.location.reload();
            })
            .catch(err => {
                console.log(err)
            })

    };

    const handleUpdatePassword = (e) => {
        e.preventDefault();
        const dadosEditados = {
            Company_ID: profileData?.Company_ID,
            password
        };

        if (password === passwordConfirm) {
            newCompany.putPasswordInPlataform(dadosEditados, axiosConfig)
                .then(response => {
                    setMenssageStatus(response.data)
                    setShow(true)
                })
                .catch(error => {
                    console.log(error);
                });
        } else {
            setShow(true)
            setMenssageStatus("Senhas divergentes")
        }
    };

    const handleCepSeach = () => {
        axios.get(`https://viacep.com.br/ws/${cep}/json/`)
            .then(response => {


                if (response.data.erro) {
                    alert("CEP não encontrado. Verifique se digitou corretamente.");
                    return;
                }


                setLogradouro(response?.data?.logradouro)
                setBairro(response?.data?.bairro)
                setLocalidade(response?.data?.localidade)
                setUf(response?.data?.estado)
                setCepResult(response?.data?.cep)
                setIbeCode(response.data.ibge)
                setRegion(response?.data?.regiao)
                setNumber(profileData?.address?.Number)
                setSigla(response?.data?.uf)
                setAddress({
                    idCompany: userDatas?.Company_ID,
                    idAddress: userDatas?.address?.Address_ID,
                    name: response?.data?.logradouro,
                    cep: response?.data?.cep,
                    number: profileData?.address?.Number,
                    bairro: response?.data?.bairro,
                    ibeCode: response?.data?.ibge,
                    city: response?.data?.localidade,
                    state: response?.data?.estado,
                    uf: response?.data?.uf,
                    region: response?.data?.regiao
                })

                setFetchTimestampApp(Date.now())
            })
            .catch(err => {
                console.log(err)
            })
    }



    const hangleSendCep = (e) => {
        e.preventDefault();

        const finalAddress = {
            idCompany: userDatas?.Company_ID,
            idAddress: userDatas?.address.Address_ID,
            name: logradouro,
            cep: cepResult,
            number: number,
            bairro: bairro,
            ibeCode: ibeCode,
            city: localidade,
            state: uf,
            uf: sigla,
            region: region
        };

        newCompany.aditAddressCompany(finalAddress, axiosConfig)
            .then(response => {
                window.location.reload();
            })
            .catch(err => { });
    };



    return (
        <div className={'area-profile-datas'}>
            {
                size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
                    (<>
                        <Navbar expand="lg" className="bg-body-tertiary sticky-navbar">
                            <Container>
                                <Navbar.Brand href="#home">
                                    <div className='area-icon-profile-mobile'> <FaUser className='icon-user-profile' /> </div>
                                </Navbar.Brand>
                                <Navbar.Brand href="#home">
                                    {
                                        isEditData ?
                                            (<div className='d-flex aling-items-center justify-content-between'>
                                                <button onClick={handleEditDatas} className='btn w-50 btn-outline-danger'>Cancelar</button>
                                                <div style={{ visibility: "hidden" }}>***</div>
                                                <button onClick={handleSubmitEdicao} className='btn  w-50 btn-warning'>Salvar</button>
                                            </div>)
                                            :
                                            <button onClick={handleEditDatas} className='btn btn-outline-secondary'>Alterar dados</button>
                                    }
                                </Navbar.Brand>

                            </Container>
                        </Navbar>






                        {
                            isEditData ?
                                (
                                    <div className='area-middle-card-profile'>
                                        <Card className='middle-card-profile'>
                                            <Card.Header style={{ backgroundColor: "transparent" }}>
                                                <h4 className='text-secondary text-center'>Informações da Empresa</h4>
                                            </Card.Header>
                                            <Card.Body>


                                                <div className='title-data-midller'>Empresa:</div>
                                                <div className='response-data-midller'>
                                                    {loadData ? <div className='load-datas'>Carregando...</div> :
                                                        <input
                                                            className='form-control'
                                                            defaultValue={nomeEmpresa}
                                                            onChange={(e) => setNomeEmpresa(e.target.value)}
                                                        />}
                                                </div>

                                                <hr />

                                                <div className='title-data-midller'>CNPJ:</div>
                                                <div className='response-data-midlle '>
                                                    {loadData ? <div className='load-datas'>Carregando...</div> :
                                                        <input
                                                            name="cnpj"
                                                            value={cnpj}
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/\D/g, '');
                                                                if (value.length <= 14) setCnpj(value);
                                                            }}
                                                            className="form-control"
                                                            maxLength={14}
                                                            type="text"
                                                            placeholder="Apenas números"
                                                        />
                                                    }
                                                </div>

                                                <hr />


                                                <div className='title-data-midller'>Endereço Atual:</div>
                                                <div className='response-data-midller'>
                                                    {loadData ? <div className='load-datas'>Carregando...</div> :
                                                        <div style={{ opacity: ".7" }}>{endereco}</div>}
                                                </div>

                                                <br></br>
                                                <div className='bg-area-edit-address'>
                                                    <div>
                                                        <label className="w-100" htmlFor='searchCep'>
                                                            <input

                                                                required
                                                                maxLength={8}
                                                                inputMode="numeric"
                                                                pattern="[0-9]{8}"
                                                                className="form-control"
                                                                placeholder="Digite seu CEP"
                                                                type="text"
                                                                id="searchCep"
                                                                value={cep}
                                                                onChange={(e) => {
                                                                    const raw = e?.target?.value || '';
                                                                    const value = raw.replace(/\D/g, '');
                                                                    if (value.length <= 8) setCep(value);
                                                                }}
                                                            />
                                                            <br></br>
                                                            <button
                                                                type="button"
                                                                className='btn btn-outline-secondary w-100'
                                                                onClick={handleCepSeach}
                                                            >
                                                                Pesquisar
                                                            </button>
                                                        </label>

                                                    </div>
                                                    <br></br><br></br>

                                                    <form onSubmit={hangleSendCep}>

                                                        <input
                                                            required
                                                            className="form-control mb-2"
                                                            type="text"
                                                            value={logradouro}
                                                            onChange={(e) => setLogradouro(e.target.value)}
                                                        />
                                                        <div className="d-flex mb-2">
                                                            <input className="w-25" type="text" disabled value="Numero:" />
                                                            <input required={true} className='form-control w-75 ' onChange={(e) => { setNumber(e.target.value) }} defaultValue={profileData?.address?.Number} type='text' />
                                                        </div>
                                                        <input required={true} className='form-control mb-2' value={bairro} onChange={(e) => setBairro(e.target.value)} type='text' />

                                                        <div className="d-flex mb-2">
                                                            <input className='form-control w-75' disabled value={localidade} onChange={(e) => setLocalidade(e.target.value)} type='text' />
                                                            <input className='form-control w-25 text-center' disabled value={sigla} onChange={(e) => setSigla(e.target.value)} type='text' />
                                                        </div>

                                                        <div className="d-flex">
                                                            <input className="w-25" type="text" disabled value="CEP" />
                                                            <input
                                                                className="form-control w-75"
                                                                type="text"
                                                                disabled
                                                                value={cepResult.replace(/\D/g, '')}
                                                            />
                                                        </div>
                                                        <br></br>
                                                        {
                                                            logradouro?.length < 2 ?
                                                                (<></>)
                                                                :
                                                                (<button className='btn w-100 btn-warning' >Salvar novo endereço</button>)
                                                        }
                                                    </form>
                                                    <br></br>
                                                </div>
                                                <hr />


                                                <div className='title-data-midller'>Telefone:</div>
                                                <div className='response-data-midller w-100'>
                                                    {loadData ? <div className='load-datas'>Carregando...</div> :
                                                        <input
                                                            name="telefone1"
                                                            value={telefone}
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/\D/g, '');
                                                                if (value.length <= 11) setTelefone(value);
                                                            }}
                                                            className="form-control"
                                                            placeholder="XX XXXXX-XXXX"
                                                            required
                                                            maxLength={11}
                                                            type="text"
                                                        />
                                                    }
                                                </div>

                                                <hr />


                                                <div className='title-data-midller'>E-mail Corporativo:</div>
                                                <div className='response-data-midller w-100'>
                                                    {loadData ? <div className='load-datas'>Carregando...</div> :
                                                        <input
                                                            className='form-control'
                                                            defaultValue={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                        />}
                                                </div>

                                                <hr />


                                                <div className='title-data-midller'>Website:</div>
                                                <div className='response-data-midller w-100'>
                                                    {loadData ? <div className='load-datas'>Carregando...</div> :
                                                        <input
                                                            className='form-control'
                                                            defaultValue={site}
                                                            onChange={(e) => setSite(e.target.value)}
                                                        />}
                                                </div>
  
                                                <hr />
                                                

                                                <div className='title-data-midller'>Comprador:</div>
                                                <div className='response-data-midller w-100'>
                                                    {loadData ? <div className='load-datas'>Carregando...</div> :
                                                        <input
                                                            className='form-control'
                                                            defaultValue={comprador}
                                                            onChange={(e) => setComprador(e.target.value)}
                                                        />}
                                                </div>

                                                <hr />
                                            </Card.Body>
                                        </Card>
                                    </div>
                                )
                                :
                                (<div className='area-middle-card-profile'>
                                    <Card className='middle-card-profile'>
                                        <Card.Header style={{ backgroundColor: "transparent" }}> <h4 className='text-secondary text-center'>Informações da Empresa</h4></Card.Header>
                                        <Card.Body>
                                            <div className='title-data-midller'>Empresa:</div><div className='response-data-midller'>{loadData ? <div className='load-datas'>Carregando...</div> : profileData?.Corporate_Name}</div>
                                            <div className="separete_line"></div>
                                            <div className='title-data-midller'>CNPJ:</div><div className='response-data-midller'>{loadData ? <div className='load-datas'>Carregando...</div> : formats.formatarCNPJ(profileData?.CNPJ)}</div>
                                            <div className="separete_line"></div>
                                            <div className='title-data-midller'>Endereço:</div><div className='response-data-midller'>
                                                {loadData ? <div className='load-datas'>Carregando...</div> : `${profileData?.address?.Name}, 
                            ${profileData?.address?.Number} - 
                            ${profileData?.address?.neighborhood?.Name}, 
                            ${profileData?.address?.city?.Name} - 
                            ${profileData?.address?.state?.Uf}, 
                            ${formats.formatCep(profileData?.address?.Cep)}`}
                                            </div>
                                            <div className="separete_line"></div>
                                            <div className='title-data-midller'>Telefone:</div><div className='response-data-midller'>{loadData ? <div className='load-datas'>Carregando...</div> : formats.formatTelefoneFixo(profileData?.Landline)}</div>
                                            <div className="separete_line"></div>
                                            <div className='title-data-midller'>E-mail Corporativo:</div><div className='response-data-midller'>{loadData ? <div className='load-datas'>Carregando...</div> : profileData?.Email}</div>
                                            <div className="separete_line"></div>
                                            <div className='title-data-midller'>Website:</div><div className='response-data-midller'>{loadData ? <div className='load-datas'>Carregando...</div> : profileData?.Web_Site}</div>
                                            <hr />
                                            <div className='title-data-midller'>Comprador:</div><div className='response-data-midller'>{loadData ? <div className='load-datas'>Carregando...</div> : userDatas?.user_and_companies?.[0]?.user?.Name}</div>

                                        </Card.Body>
                                    </Card>
                                </div>)
                        }
                        {
                            isEditData ?
                                (<>
                                    <br></br>
                                    <Card>
                                        <CardHeader className='text-center'>Alterar Senha</CardHeader>
                                        <Card.Body className='text-center'>
                                            <input defaultValue={password} onChange={(e) => setPassword(e.target.value)} className='form-control' type='password' placeholder='Nova senha' />
                                            <br></br>
                                            <input defaultValue={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} className='form-control' type='password' placeholder='Confirme sua senha' />
                                            <hr></hr>
                                            <button onClick={handleUpdatePassword} className='btn  w-100 btn-warning'>Salvar</button>
                                        </Card.Body>
                                    </Card>
                                </>)
                                :
                                <></>
                        }
                    </>)
                    :
                    (
                        <>
                            <div className='area-profile-contacts'>
                                <Card>
                                    <Card.Body className='text-center'>
                                        <br></br><br></br><br></br>
                                        <div className='area-icon-profile'> <FaUser className='icon-user-profile' /> </div>
                                        <br></br>
                                        <h5>{loadData ? <div className='load-datas'>Carregando...</div> : userDatas?.Name}</h5>
                                        {loadData ? <div className='load-datas'>Carregando...</div> : <i>CNPJ: {formats.formatarCNPJ(profileData?.CNPJ)}</i>}
                                        <br></br><br></br>
                                        {
                                            isEditData ?
                                                (<div className='d-flex aling-items-center justify-content-between'>
                                                    <button onClick={handleEditDatas} className='btn w-50 btn-outline-danger'>Cancelar</button>
                                                    <div style={{ visibility: "hidden" }}>***</div>
                                                    <button onClick={handleSubmitEdicao} className='btn  w-50 btn-warning'>Salvar</button>
                                                </div>)
                                                :
                                                <button onClick={handleEditDatas} className='btn btn-outline-secondary'>Alterar dados</button>
                                        }
                                    </Card.Body>
                                </Card>
                                <br></br>

                                {
                                    isEditData ?
                                        (<Card>
                                            <CardHeader className='text-center'>Alterar Senha</CardHeader>
                                            <Card.Body className='text-center'>
                                                <input defaultValue={password} onChange={(e) => setPassword(e.target.value)} className='form-control' type='password' placeholder='Nova senha' />
                                                <br></br>
                                                <input defaultValue={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} className='form-control' type='password' placeholder='Confirme sua senha' />
                                                <hr></hr>
                                                <button onClick={handleUpdatePassword} className='btn  w-100 btn-warning'>Salvar</button>
                                            </Card.Body>
                                        </Card>)
                                        :
                                        <></>
                                }

                            </div>
                            {
                                isEditData ?
                                    (
                                        <div className='area-middle-card-profile'>
                                            <Card className='middle-card-profile'>
                                                <Card.Body>
                                                    <Card.Header style={{ backgroundColor: "transparent" }}>
                                                        <h4 className='text-secondary text-center'>Informações da Empresa</h4>
                                                    </Card.Header>
                                                    <br />

                                                    <div className='d-flex align-items-center'>
                                                        <div className='title-data-midller'>Nome da Empresa:</div>
                                                        <div className='response-data-midller w-50'>
                                                            {loadData ? <div className='load-datas'>Carregando...</div> :
                                                                <input
                                                                    className='form-control'
                                                                    defaultValue={nomeEmpresa}
                                                                    onChange={(e) => setNomeEmpresa(e.target.value)}
                                                                />}
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <div className='d-flex align-items-center'>
                                                        <div className='title-data-midller'>CNPJ:</div>
                                                        <div className='response-data-midller w-50'>
                                                            {loadData ? <div className='load-datas'>Carregando...</div> :
                                                                <input
                                                                    name="cnpj"
                                                                    value={cnpj}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value.replace(/\D/g, '');
                                                                        if (value.length <= 14) setCnpj(value);
                                                                    }}
                                                                    className="form-control"
                                                                    maxLength={14}
                                                                    type="text"
                                                                    placeholder="Apenas números"
                                                                />
                                                            }
                                                        </div>
                                                    </div>
                                                    <hr />

                                                    <div className='d-flex align-items-center'>
                                                        <div className='title-data-midller'>Endereço Atual:</div>
                                                        <div className='response-data-midller w-75'>
                                                            {loadData ? <div className='load-datas'>Carregando...</div> :
                                                                <div style={{ opacity: ".7" }}>{endereco}</div>}
                                                        </div>
                                                    </div>
                                                    <br></br>
                                                    <div className='bg-area-edit-address'>
                                                        <div>
                                                            <label className='d-flex align-items-center w-25' htmlFor='searchCep'>
                                                                <input
                                                                    style={{ marginRight: "10px" }}
                                                                    required
                                                                    maxLength={8}
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]{8}"
                                                                    className="form-control"
                                                                    placeholder="Digite seu CEP"
                                                                    type="text"
                                                                    id="searchCep"
                                                                    value={cep}
                                                                    onChange={(e) => {
                                                                        const raw = e?.target?.value || '';
                                                                        const value = raw.replace(/\D/g, '');
                                                                        if (value.length <= 8) setCep(value);
                                                                    }}
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className='btn btn-outline-secondary'
                                                                    onClick={handleCepSeach}
                                                                >
                                                                    Pesquisar
                                                                </button>
                                                            </label>

                                                        </div>
                                                        <br></br>
                                                        <form onSubmit={hangleSendCep}>
                                                            <div style={{ marginBottom: "2vh" }} className='d-flex'>
                                                                <input
                                                                    required
                                                                    style={{ width: "80%", marginRight: "10px" }}
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={logradouro}
                                                                    onChange={(e) => setLogradouro(e.target.value)}
                                                                />
                                                                <input required={true} style={{ width: "10%", marginRight: "10px" }} className='form-control text-center ' onChange={(e) => { setNumber(e.target.value) }} defaultValue={profileData?.address?.Number} type='text' />
                                                                <input required={true} style={{ width: "40%", marginRight: "10px" }} className='form-control' value={bairro} onChange={(e) => setBairro(e.target.value)} type='text' />
                                                                <input style={{ width: "30%", marginRight: "10px" }} className='form-control' disabled value={localidade} onChange={(e) => setLocalidade(e.target.value)} type='text' />
                                                                <input style={{ width: "10%", marginRight: "10px" }} className='form-control text-center' disabled value={sigla} onChange={(e) => setSigla(e.target.value)} type='text' />
                                                                <input
                                                                    style={{ width: "20%" }}
                                                                    className="form-control"
                                                                    type="text"
                                                                    disabled
                                                                    value={cepResult.replace(/\D/g, '')}
                                                                />
                                                            </div>

                                                            <div className='d-flex justify-content-between'>
                                                                <div></div>

                                                                {
                                                                    logradouro?.length < 2 ?
                                                                        (<></>)
                                                                        :
                                                                        (<button style={{ width: "20%" }} className='btn btn-warning' >Salvar novo endereço</button>)
                                                                }

                                                            </div>
                                                        </form>
                                                    </div>
                                                    <hr />

                                                    <div className='d-flex align-items-center'>
                                                        <div className='title-data-midller'>Telefone:</div>
                                                        <div className='response-data-midller w-50'>
                                                            {loadData ? <div className='load-datas'>Carregando...</div> :
                                                                <input
                                                                    name="telefone1"
                                                                    value={telefone}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value.replace(/\D/g, '');
                                                                        if (value.length <= 11) setTelefone(value);
                                                                    }}
                                                                    className="form-control"
                                                                    placeholder="XX XXXXX-XXXX"
                                                                    required
                                                                    maxLength={11}
                                                                    type="text"
                                                                />
                                                            }
                                                        </div>
                                                    </div>
                                                    <hr />

                                                    <div className='d-flex align-items-center'>
                                                        <div className='title-data-midller'>E-mail Corporativo:</div>
                                                        <div className='response-data-midller w-50'>
                                                            {loadData ? <div className='load-datas'>Carregando...</div> :
                                                                <input
                                                                    className='form-control'
                                                                    defaultValue={email}
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                />}
                                                        </div>
                                                    </div>
                                                    <hr />

                                                    <div className='d-flex align-items-center'>
                                                        <div className='title-data-midller'>Website:</div>
                                                        <div className='response-data-midller w-50'>
                                                            {loadData ? <div className='load-datas'>Carregando...</div> :
                                                                <input
                                                                    className='form-control'
                                                                    defaultValue={site}
                                                                    onChange={(e) => setSite(e.target.value)}
                                                                />}
                                                        </div>
                                                    </div>

                                                    <hr />
                                                    <br></br><br></br>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='title-data-midller'>Comprador:</div>
                                                        <div className='response-data-midller w-50'>
                                                            {loadData ? <div className='load-datas'>Carregando...</div> :
                                                                <input
                                                                    className='form-control'
                                                                    defaultValue={comprador}
                                                                    onChange={(e) => setComprador(e.target.value)}
                                                                />}
                                                        </div>
                                                    </div>
                                                    <hr />
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    )
                                    :
                                    (<div className='area-middle-card-profile'>
                                        <Card className='middle-card-profile'>
                                            <Card.Body>
                                                <Card.Header style={{ backgroundColor: "transparent" }}> <h4 className='text-secondary text-center'>Informações da Empresa</h4></Card.Header>
                                                <br></br>
                                                <div className='d-flex align-items-center'><div className='title-data-midller'>Nome da Empresa:</div><div className='response-data-midller'>{loadData ? <div className='load-datas'>Carregando...</div> : profileData?.Corporate_Name}</div></div>
                                                <hr></hr>
                                                <div className='d-flex align-items-center'><div className='title-data-midller'>CNPJ:</div><div className='response-data-midller'>{loadData ? <div className='load-datas'>Carregando...</div> : formats.formatarCNPJ(profileData?.CNPJ)}</div></div>
                                                <hr></hr>
                                                <div className='d-flex align-items-center'><div className='title-data-midller'>Endereço:</div><div className='response-data-midller'>
                                                    {loadData ? <div className='load-datas'>Carregando...</div> : `${profileData?.address?.Name}, 
                            ${profileData?.address?.Number} - 
                            ${profileData?.address?.neighborhood?.Name}, 
                            ${profileData?.address?.city?.Name} - 
                            ${profileData?.address?.state?.Uf}, 
                            ${formats.formatCep(profileData?.address?.Cep)}`}
                                                </div></div>
                                                <hr></hr>
                                                <div className='d-flex align-items-center'><div className='title-data-midller'>Telefone:</div><div className='response-data-midller'>{loadData ? <div className='load-datas'>Carregando...</div> : formats.formatTelefoneFixo(profileData?.Landline)}</div></div>
                                                <hr></hr>
                                                <div className='d-flex align-items-center'><div className='title-data-midller'>E-mail Corporativo:</div><div className='response-data-midller'>{loadData ? <div className='load-datas'>Carregando...</div> : profileData?.Email}</div></div>
                                                <hr></hr>
                                                <div className='d-flex align-items-center'><div className='title-data-midller'>Website:</div><div className='response-data-midller'>{loadData ? <div className='load-datas'>Carregando...</div> : profileData?.Web_Site}</div></div>
                                                <hr />
                                                <br></br><br></br>
                                                <div className='d-flex align-items-center'><div className='title-data-midller'>Comprador:</div><div className='response-data-midller'>{loadData ? <div className='load-datas'>Carregando...</div> : userDatas?.user_and_companies?.[0]?.user?.Name}</div></div>
                                                <hr></hr>
                                            </Card.Body>
                                        </Card>
                                    </div>)
                            }
                        </>
                    )

            }


            <Modal show={show} onHide={handleClose}>
                <Modal.Body className='text-center'>{menssageStatus}</Modal.Body>
            </Modal>
        </div >
    )
}

export default ProfileDatas